export class ProfileInterest {
  public token: string;
  public name: string;
  public slug: string;
  public type: string;
  public dataSource: string;
  public hasSpecialty: boolean;
  public createdAt?: Date;
  public updatedAt?: Date;
}
